/**
 * Custom jQuery plugin to toggle display of search bar field
 * Expects standard WP search form with classes for .search-field and .search-submit
 *
 * When search field is empty, submit button toggles display of search field.
 * Otherwise, button submits normally. Field auto hides after a second if it
 * loses focus.
 *
 * @since	3/26/14
 * @author	<corey@chatmandesign.com>
 * @link		http://chatmandesign.com
 */

jQuery.fn.cdSearchSlideout = function () {
	var $s = this;
	var $field = $s.find(".search-field");
	var $button = $s.find(".search-submit");

	$button.click(function (e) {
		if (!$s.hasClass("is-open")) {
			e.preventDefault();
			$s.addClass("is-open");
			window.setTimeout(function () {
				// Slight delay before focus to prevent wiggy behavior in Safari
				$field.focus();
			}, 200);
		} else if (!$field.val()) {
			e.preventDefault();
			$s.removeClass("is-open");
		}
	});
	$field.blur(function () {
		// Auto hide if field loses focus
		window.setTimeout(function () {
			if (!$button.is(":focus") && !$field.is(":focus")) {
				$s.removeClass("is-open");
			}
		}, 1000);
	});

	return this;
};

jQuery(".search-slideout").cdSearchSlideout();
